module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGFhZ18xIiBkYXRhLW5hbWU9IkxhYWcgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzMuNCAzMy4yNSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM2Zjk7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5zaG93VGVrZW5nZWJpZWQgMjwvdGl0bGU+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjI5LjMzIDAgMTYuNzcgMTIuNTYgNC4yMSAwIDAgNC4yMSAxMi42MyAxNi43NyAwLjA3IDI5LjI2IDQuMDYgMzMuMjUgMTYuNyAyMC43NiAyOS4yNiAzMy4yNSAzMy40IDI5LjExIDIwLjg0IDE2LjYzIDMzLjMyIDQuMDYgMjkuMzMgMCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x.svg
// module id = 436
// module chunks = 2